/* eslint-disable */
import { stopSubmit, SubmissionError } from 'redux-form';
import { call, put, select } from 'redux-saga/effects'
import { path } from 'ramda'
import AuthActions from '../Redux/AuthRedux'
import UserActions from '../Redux/UserRedux'
import StartupTypes from '../Redux/StartupRedux'
//import OneSignal from 'react-native-onesignal'
import NotificationManager from '../Lib/NotificationManager'
//import RNFetchBlob from 'react-native-fetch-blob'
import { NavigationActions } from 'react-navigation';
import { OfflineMessaging } from '../Services/OfflineMessaging'
import { alertView, getDeviceLanguage, deepClone } from '../Lib/utils';

const defaultScreen = 'home' // blank (for testing crash)

const s3Upload = (urlUpload,base64) => {
  console.tron.display({
    name: 's3Upload',
    preview: 'details',
    value: {
      base64: base64,
      urlUpload: urlUpload,
      // details: detailsppro
    }
  })
  let { avatar, avatarOrig } =urlUpload
  const headers = {
    'Content-Type' : 'application/octet-stream',
  }
    
    if (false)
    return RNFetchBlob.fetch ( 'PUT', avatar._url, headers, base64 )
    .then( ( ) =>  RNFetchBlob.fetch ( 'PUT', avatarOrig._url, headers, base64 ) )
    .catch(error => console.tron.display({
    name: `error upload`,
     preview :``,
    value: {
    state: error
    }
    })
     )

}

const getGroup = function * getGroup ( api, action ) {
	try {
		console.log(`getGroup starts`);
		// const { UserId } = action
		const response = yield call(api.getGroup)
		if (response.ok) {
			console.log(`getGroup api call success`);
			const fullState = yield select() // the entire app state
			const authState = fullState.auth
			const userId = authState.user.UserId
			const apiResponse = response.data
			const data = apiResponse.data // { UserIds: [ 'AS5758b527028b600001ac1f18a32d6c', 's8h2uG09N2CyA7' ],
			// remove self
			const userIds = data.UserIds.filter((item) => {
				return item != userId
			})
			const list = data.list.filter((item) => {
				return item['UserId'] != userId
			})
			console.log(`getGroup list ` + JSON.stringify(list));
			const groupChanges = {
				fetching: false,
				error: null,
				errorCode: null,
				logRef: apiResponse.logRef,
				modified: Date.now(),
				groupId: data.GroupId,
				userIds,
				list,
			}
			yield put(AuthActions.groupResult(groupChanges))
		} else {
			// const RESULT_MC_GET_NO_GROUP              = 7130;
			// const RESULT_MC_GET_MISSING_GROUP         = 7131;
			console.log(`getGroup not ok`);
			const { data } = response
			const apiResponse = data
			const error = apiResponse.errors[0]
			console.log(`getGroup errorMessage: ${error.detail}, errorCode, ${error.code}`)
			// yield put(AuthActions.changePasswordFailure(errorMessage))
			const groupChanges = {
				fetching: false,
				error: error.detail,
				errorCode: error.code,
				logRef: apiResponse.logRef,
				modified: Date.now(),
				groupId: null,
				userIds: [],
				list: [],
			}
			yield put(AuthActions.groupResult(groupChanges))
		}
	}
	catch (e) {
		console.log(`getGroup exception ` + e.message);
		console.tron.display({name: 'getGroup error', preview: "expand", value: {message: e.message, e: e}})
		yield put(AuthActions.groupResult({}))
	}
}

const switchToGroupUser = function * switchToGroupUser ( api, action ) {
	try {
		console.log(`switchToGroupUser starts`);
    api.cacheDeleteAll()
		const { UserId, switchPostHints } = action
		const response = yield call(api.switchToGroupUser, UserId)
		if (response.ok) {
			const apiResponse = response.data
			console.log('switchToGroupUser apiResponse ' + JSON.stringify(apiResponse))

			const user = apiResponse.data[0]
			const notifId = user.NotificationId
      const newToken = apiResponse.accessToken
			const userCurrency = typeof user.Currency == 'undefined' || user.Currency == null ? null : user.Currency
			// console.log("loc 3 setting notifId = " + notifId)
			// OneSignal.sendTag('kargoe_username', notifId)

			NotificationManager.postNotification("AuthRedux_logoutRequest") // clear out the home screen startup snapshot, it will be wrong!
			yield call(api.clearAuthorization)
      // yield put(AuthActions.logoutSuccess()) // black screen spinner
      yield put({ type : 'WEBSOCKET_DISCONNECT' })
			const switchToNeutralScreenAction = NavigationActions.reset({
				index: 0, key: null, actions: [NavigationActions.navigate({ routeName: 'auth' })]
			})
			const switchToHomeScreenAction = NavigationActions.reset({
				index: 0, key: null, actions: [NavigationActions.navigate({ routeName: 'home', params: { switchUserId: UserId, switchPostHints, isScroll : true, from: 'switchToGroupUser' } })]
			})
      // yield put(switchToNeutralScreenAction) // cannot be dealing with pending sagas/api responses from old user
			yield put(AuthActions.switchSuccess(response)) // authSuccess
      //OneSignal.sendTag('kargoe_username', notifId) // 'kargoeUserNotLoggedIn'
			if (userCurrency == null)
				yield put(UserActions.setUserDefaultCurrency())
      // yield put(switchToHomeScreenAction)
      yield call(api.setAuthorization, newToken)
      yield call(getGroup, api, action) // api, action
		} else {
			console.log(`switchToGroupUser not ok`);
			const { data } = response
			const apiResponse = data
			const error = apiResponse.errors[0]
			console.log(`switchToGroupUser errorMessage: ${error.detail}, errorCode, ${error.code}`)
		}
	}
	catch (e) {
		console.log('switchToGroupUser message: ' + e.message + ', error: ' + JSON.stringify(e))
		yield put(AuthActions.groupResult({}))
	}
}

const groupAddUser = function * groupAddUser ( api, action ) {
	try {
		const { UserId } = action
		console.log(`groupAddUser starts, UserId`, UserId);
		const response = yield call(api.addUserToGroup, UserId)
		if (response.ok) {
			const apiResponse = response.data
			console.log('groupAddUser apiResponse ' + JSON.stringify(apiResponse))
			const fullState = yield select() // the entire app state
			const authState = fullState.auth
			const userId = authState.user.UserId
			const data = apiResponse.data // { UserIds: [ 'AS5758b527028b600001ac1f18a32d6c', 's8h2uG09N2CyA7' ],
			// remove self
			console.log('groupAddUser auth UserId', userId,', returned userIds', data.UserIds)
			const userIds = data.UserIds.filter((item) => {
				return item != userId
			})
			console.log(`groupAddUser new userIds`, userIds);
			const groupChanges = {
				fetching: false,
				error: null,
				errorCode: null,
				logRef: apiResponse.logRef,
				modified: Date.now(),
				groupId: data.GroupId,
				userIds,
			}
			yield put(AuthActions.groupResult(groupChanges))
		} else {
			// const RESULT_MC_GET_NO_GROUP              = 7130;
			// const RESULT_MC_GET_MISSING_GROUP         = 7131;
			console.log(`groupAddUser not ok`);
			const { data } = response
			const apiResponse = data
			const error = apiResponse.errors[0]
			console.log(`groupAddUser errorMessage: ${error.detail}, errorCode, ${error.code}`)
			// yield put(AuthActions.changePasswordFailure(errorMessage))
			const groupChanges = {
				fetching: false,
				error: error.detail,
				errorCode: error.code,
				logRef: apiResponse.logRef,
				modified: Date.now(),
				groupId: null,
				userIds: [],
			}
			yield put(AuthActions.groupResult(groupChanges))
		}
	}
	catch (e) {
		console.tron.display({name: 'groupAddUser error', preview: "expand", value: {message: e.message, e: e}})
		yield put(AuthActions.groupResult({}))
	}
}

const groupRemoveUser = function * groupRemoveUser ( api, action ) {
	try {
		const { UserId } = action
		console.log(`groupRemoveUser starts, UserId`, UserId);
		const response = yield call(api.removeUserFromGroup, UserId)
		if (response.ok) {
			const apiResponse = response.data
			console.log('groupRemoveUser apiResponse ' + JSON.stringify(apiResponse))
			const fullState = yield select() // the entire app state
			const authState = fullState.auth
			const userId = authState.user.UserId
			const data = apiResponse.data // { UserIds: [ 'AS5758b527028b600001ac1f18a32d6c', 's8h2uG09N2CyA7' ],
			// remove self
			console.log('groupRemoveUser auth UserId', userId,', returned userIds', data.UserIds)
			const userIds = data.UserIds.filter((item) => {
				return item != userId
			})
			const list = data.list.filter((item) => {
				return item['UserId'] != userId
			})
			console.log(`groupRemoveUser new userIds`, userIds);
			const groupChanges = {
				fetching: false,
				error: null,
				errorCode: null,
				logRef: apiResponse.logRef,
				modified: Date.now(),
				groupId: data.GroupId,
				userIds,
				list,
			}
			yield put(AuthActions.groupResult(groupChanges))
		} else {
			// const RESULT_MC_GET_NO_GROUP              = 7130;
			// const RESULT_MC_GET_MISSING_GROUP         = 7131;
			console.log(`groupRemoveUser not ok`);
			const { data } = response
			const apiResponse = data
			const error = apiResponse.errors[0]
			console.log(`groupRemoveUser errorMessage: ${error.detail}, errorCode, ${error.code}`)
			// yield put(AuthActions.changePasswordFailure(errorMessage))
			const groupChanges = {
				fetching: false,
				error: error.detail,
				errorCode: error.code,
				logRef: apiResponse.logRef,
				modified: Date.now(),
				groupId: null,
				userIds: [],
			}
			yield put(AuthActions.groupResult(groupChanges))
		}
	}
	catch (e) {
		console.tron.display({name: 'groupRemoveUser error', preview: "expand", value: {message: e.message, e: e}})
		yield put(AuthActions.groupResult({}))
	}
}

const addProfile = function * addProfile ( api, action ) {
	// passed screen (login/signup), save current auth and user settings to auth.profile, logout and redirect to new screen
	try {
		const { screen } = action
		const routeName = screen == 'login' ? 'auth' : 'signup'
		console.log(`addProfile screen`, screen);

		NotificationManager.postNotification("AuthRedux_logoutRequest") // clear out the home screen startup snapshot, it will be wrong!
		yield call(api.clearAuthorization)
		// yield put(AuthActions.logoutSuccess()) // changes to state made in addProfileRequest are not present...
		yield put({ type : 'WEBSOCKET_DISCONNECT' })
		const switchToLoginScreenAction = NavigationActions.reset({
			index: 0, key: null, actions: [NavigationActions.navigate({ routeName })]
		})
		console.log(`addProfile switching`);
		yield put(switchToLoginScreenAction)
	}
	catch (e) {
		console.tron.display({name: 'addProfile error', preview: "expand", value: {message: e.message, e: e}})
	}
}

const cancelAddProfile = function * cancelAddProfile ( api, action ) {
	// restore current auth and user settings from auth.profile, and redirect to home wall
	try {
		console.log(`cancelAddProfile starts`);

		const fullState = yield select() // the entire app state
		const authState = fullState.auth
		const authBackup = authState.authBackup

		// yield put(AuthActions.authSuccess(response)) // already done within redux request
		const user = authBackup.user // which should be the same as authState.user
		console.log(`cancelAddProfile user from backup`, user);
		const userCurrency = typeof user.Currency == 'undefined' || user.Currency == null ? null : user.Currency
		//OneSignal.sendTag('kargoe_username', user.NotificationId)
		if (userCurrency == null)
			yield put(UserActions.setUserDefaultCurrency())
		const switchToHomeScreenAction = NavigationActions.reset({
			index: 0, key: null, actions: [NavigationActions.navigate({ routeName: 'home', params: { isScroll : true, from: 'cancelAddProfile' } })]
		})
		yield put(switchToHomeScreenAction)
	}
	catch (e) {
		console.log('cancelAddProfile message: ' + e.message + ', error: ' + JSON.stringify(e))
	}
}






const renewToken = function* renewToken(api, action) {
  console.log("*** renewToken")
  try {
    console.tron.display({
      name: 'api renewToken response',
      preview: 'expand',
      value: {
        response: action
      }
    })
    const { token } = action
    // make the call to the api

    const response = yield call(api.renewToken, token)
    console.tron.display({
      name: 'api renewToken response',
      preview: 'expand',
      value: {
        response: action
      }
    })

    if (response.ok) {

      // const { response } = action // catch: undefined is not an object (evaluating '_response.data')
      const { data } = response
      const apiResponse = data
      const newToken = apiResponse.accessToken
      console.tron.display({
        name: 'api renewToken apiResponse',
        preview: 'expand',
        value: {
          apiResponse: apiResponse
        }
      })
      yield call(api.setAuthorization, newToken)
      // do data conversion here if needed
      yield put(AuthActions.authSuccess(response))

      const resetAction1 = NavigationActions.reset({
        index: 0,
        key: null,
        actions: [
          NavigationActions.navigate({ routeName: 'home', params : {
            isScroll : true,
            from: 'renewToken'
          }}),
        ],
      })
      yield put(resetAction1)
      yield put({ type : 'WEBSOCKET_INIT' })
    } else {
      yield put(AuthActions.authFailure(response))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'renewToken error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }
}

const nonSagaLogin = function * nonSagaLogin ( api, action ) {
	// standard login uses this code
	console.log(`nonSagaLogin action ` + JSON.stringify(action))
  api.cacheDeleteAll()
	const { response } = action
	const appState = yield select()
	const authState = appState.auth
let isLogin = true
	if (response.config && response.config.url && response.config.url.includes("public/signup"))
		isLogin = false
	const loginSucceeded = action.response.data && action.response.data.data && action.response.data.data.length > 0
	
	console.log("nonSagaLogin continue with normal login") // *** What about GroupId??
  yield call(api.setAuthorization, action.response.data.accessToken)
  yield put({ type : 'WEBSOCKET_INIT' })
  if (action.response.data && action.response.data.data && action.response.data.data.length > 0) {
    const user = action.response.data.data[0]
    const notifId = user.NotificationId
    const userCurrency = typeof user.Currency == 'undefined' || user.Currency == null ? null : user.Currency
    console.log("loc 3 setting notifId = " + notifId)
    //OneSignal.sendTag('kargoe_username', notifId)
    if (userCurrency == null)
      yield put(UserActions.setUserDefaultCurrency())

		// if we have authBackup, then use that authorization to add the new user to old user/group
		if (authState.authBackup && authState.authBackup.token) {
			// this was an addProfile call to signup
			const InvitingAccessToken = authState.authBackup.token
			console.log("nonSagaLogin calling addUserToGroup")
			const groupResponse = yield call(api.addUserToGroup, InvitingAccessToken)
			// if not groupResponse.ok then there is not much we can do about it
			if (groupResponse.ok) {
				console.log("nonSagaLogin calling addUserToGroup failed")
				const groupAPIResponse = groupResponse.data
				const groupData = groupAPIResponse.data
				console.log("nonSagaLogin data contents: " + JSON.stringify(groupData))
				const userUpdate = groupData.User
				const groupRecord = groupData.Group
				yield put(AuthActions.updateUserAndGroup(userUpdate, groupRecord)) // only currently using userUpdate
			}
			else
				console.log("nonSagaLogin calling addUserToGroup failed") // not much we can do...
		}
		console.log('nonSagaLogin now calling getGroup')
		yield call(getGroup, api, action) // api, action
	}
	if (isLogin)
		yield put(NavigationActions.reset({ index: 0, key: null,
			actions: [ NavigationActions.navigate({ routeName: 'home', params : { isScroll : true, from: 'nonSagaLogin' }})],
		}))
}

const loginUser = function* loginUser(api, action) {
  console.log("loginUser")
  try {
    // standard login does not use this code, not sure when used
    api.cacheDeleteAll()
    const { values: { username, password, resolve, reject } } = action

    const response = yield call(api.login, username, password)
    if (response.ok) {


      const { data } = response
      const apiResponse = data
      const token = apiResponse.accessToken
      const user = apiResponse.data && apiResponse.data[0] ? apiResponse.data[0] : null
      const userCurrency = typeof user.Currency == 'undefined' || user.Currency == null ? null : user.Currency
      console.tron.display({ name: `AuthSagas`, preview: `loginUser`, value: {user} })

      console.log("apiResponse = " + JSON.stringify(apiResponse))

      if (user) {
        const notifId = user.NotificationId
        console.log("loc 1 notifId = " + notifId)
        //OneSignal.sendTag('kargoe_username', notifId)
      }
      else console.log("no notification id found for newly logged in user")

      yield call(api.setAuthorization, token)

      const resetAction1 = NavigationActions.reset({
        index: 0,
        key: null,
        actions: [
          NavigationActions.navigate({ routeName: defaultScreen ,params : {
            isScroll : true
          }}),

        ],

      })
      yield call(resolve);
      yield put(stopSubmit('LoginForm'));

      yield put(AuthActions.authSuccess(response))

      if (userCurrency == null)
        yield put(UserActions.setUserDefaultCurrency())

      yield put(resetAction1)
      yield put({ type : 'WEBSOCKET_INIT' })
    } else {
      const { data: { errors } } = response
      const { fieldErrors } = errors[0]
      const error = fieldErrors[0]

      yield put(stopSubmit('LoginForm'));
      yield call(reject, new SubmissionError({ username: error.status, password: error.status }));

      yield put(AuthActions.authFailure())
    }
  }
  catch (e) {
    console.tron.display({
      name: 'loginUser error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }
}
const loginFacebook = function* loginFacebook(api, action) {


  try {
    api.cacheDeleteAll()
    const { data } = action
    const language = getDeviceLanguage()
    //yield call(api.setLanguage, language) 
    const response = yield call(api.loginFacebook,data)
    console.tron.display({
      name: `face book login saga sucess`,
       preview :``,
      value: {
      state: response,
      action : action
      }
      })
    if (response.ok) {



      const { data } = response
      const apiResponse = data
      const token = apiResponse.accessToken

      yield call(api.setAuthorization, token)

      const resetAction1 = NavigationActions.reset({
        index: 0,
        key: null,
        actions: [
          NavigationActions.navigate({ routeName: defaultScreen ,params : {
            isScroll : true
          }}),

        ],

      })

      const user = apiResponse.data[0]
      const userCurrency = typeof user.Currency == 'undefined' || user.Currency == null ? null : user.Currency
      yield put(AuthActions.facebookLoginSuccess(response))
      
      console.log(`loginFacebook user`, response, apiResponse, user)
      if (userCurrency == null)
        yield put(UserActions.setUserDefaultCurrency())
      
      yield put(resetAction1)
      yield put({ type : 'WEBSOCKET_INIT' })
    } else {
      console.tron.display({
        name: `face book login saga fail`,
       preview :``,
      value: {
      state: response
      }
      })

      const { data: { errors } } = response



      yield put(AuthActions.facebookLoginFailure(errors))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'loginFacebook error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
    yield put(AuthActions.facebookLoginFailure())
  }
}
const signupFacebook = function* signupFacebook(api, action) {


  try {

    const { data : {resolve, reject , ...restData} } = action
    console.tron.display({
    name: `signupFacebook`,
     preview :``,
    value: {
    state: restData
    }
    })
    const {base64} = restData

    const language = getDeviceLanguage()
    //yield call(api.setLanguage, language) 
    const response = yield call(api.signupFacebook,restData)

    if (response.ok) {


      console.tron.display({
        name: `face book signup saga sucess`,
         preview :``,
        value: {
        state: response,
        action : action
        }
        })
      const { data } = response
      const apiResponse = data
      const token = apiResponse.accessToken

      yield call(api.setAuthorization, token)
         const urlUpload =  yield call(api.avatar,{})

    console.tron.display({
      name: `signupFacebook urlUpload`,
       preview :``,
      value: {
        urlUpload :urlUpload,

      }
      })

    const uploadResponse = yield call(s3Upload, urlUpload.data.meta,base64)
    console.tron.display({
    name: `signupFacebook uploadResponse`,
     preview :``,
    value: {
      uploadResponse: uploadResponse,
    apiResponse: apiResponse
    }
    })

    const user = apiResponse.data[0]
    const userCurrency = typeof user.Currency == 'undefined' || user.Currency == null ? null : user.Currency
    const updateAvatar  = yield call(api.avatarUpdated, apiResponse.data[0].UserId)
    console.tron.display({
    name: `updateAvatar`,
     preview :``,
    value: {
    state: updateAvatar
    }
    })

      const resetAction1 = NavigationActions.reset({
        index: 0,
        key: null,
        actions: [
          NavigationActions.navigate({ routeName: defaultScreen ,params : {
            isScroll : true
          }}),

        ],

      })
      yield call(AuthActions.facebookSignupSuccess, response)// put(AuthActions.facebookSignupSuccess(response))
      if (userCurrency == null)
        yield put(UserActions.setUserDefaultCurrency())
      yield call(resolve);
      yield put(stopSubmit('SignupFacebookForm'));
      yield put(resetAction1)
      yield put({ type : 'WEBSOCKET_INIT' })
    } else {
      const { data: { errors } } = response
      const { fieldErrors } = errors[0]
      const error = fieldErrors[0]


      yield put(AuthActions.facebookSignupFailure(error))
      yield put(stopSubmit('SignupFacebookForm'));
      yield call(reject,
        new SubmissionError({
          username: error.name == 'Username' && error.status,
          email : error.name == 'Email' && error.status,
        }));

    }
  }
  catch (e) {

    console.tron.display({
      name: 'signup Facebook error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
    yield put(AuthActions.facebookSignupFailure(e.message))
  }

}
const logoutUser = function* logoutUser(api, action) {


  try {
    api.cacheDeleteAll()
    const response = yield call(api.logout)

    if (response.ok) {
      const { data } = response
      const apiResponse = data
      yield call(api.clearAuthorization)

      //OneSignal.sendTag('kargoe_username', 'kargoeUserNotLoggedIn')

      yield put(AuthActions.logoutSuccess())
      const resetAction1 = NavigationActions.reset({
        index: 0,
        key: null,
        actions: [
          NavigationActions.navigate({ routeName: 'auth' }),

        ],

      })
      yield put(resetAction1)
      yield put({ type : 'WEBSOCKET_DISCONNECT' })
    } else {
      yield put(AuthActions.logoutFailure())
    }
  }
  catch (e) {
    console.tron.display({
      name: 'loginout error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }
}

const updateKargoePassword = function* updateKargoePassword(api, action) {


  try {

    const { values: { username, password, resolve, reject } } = action

    const response = yield call(api.login, username, password)
    if (response.ok) {

      const { data } = response
      const apiResponse = data
      const token = apiResponse.accessToken

      yield call(api.setAuthorization, token)
      yield put({ type : 'WEBSOCKET_INIT' })
      yield call(resolve);
      yield put(AuthActions.kargoePasswordSuccess(response))
      // yield put(UserActions.updateTouchIdSuccess(response))
    } else {
      yield call(reject);
    }
  }
  catch (e) {
    yield call(reject);
  }
}

const setMode = function* setMode(api, action) {
  // do nothing, just changing the state
  yield put(AuthActions.setModeSuccess({}))
}

const changePassword = function* changePassword(api, action) {
  try {
    console.log(`PMJ changePassword`);
    const { oneTimeCode, password, confirmPassword } = action
    const response = yield call(api.changePassword, oneTimeCode, password, confirmPassword)
    if (response.ok) {
      const { data } = response
      const apiResponse = data
      const token = apiResponse.accessToken
      yield call(api.setAuthorization, token)
      // TODO - should be watching state, and flip to home, not navigating within a saga, see Login does the same
      const resetAction1 = NavigationActions.reset({
        index: 0,
        key: null,
        actions: [
          NavigationActions.navigate({ routeName: defaultScreen, params : {
            isScroll : true
          }}),
        ],
      })
      yield put(AuthActions.authSuccess(response))
      yield put(resetAction1)
      yield put({ type : 'WEBSOCKET_INIT' })
    } else {
      console.log(`PMJ changePassword error`);
      const { data: { errors } } = response
      const { fieldErrors } = errors[0]
      const errorMessage = fieldErrors[0].status
      console.log(`PMJ changePassword error fieldErrors: ` + JSON.stringify(fieldErrors))
      console.log(`PMJ changePassword errorMessage: ${errorMessage}`)
      yield put(AuthActions.changePasswordFailure(errorMessage))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'changePassword error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }
}



const signup = function* signup(api, action) {
  const language = getDeviceLanguage()
  console.log(`in auth sagas signup, language: ${language}`)
  try {
    api.cacheDeleteAll()
    const { data } = action
    console.tron.display({name: `authSagas`, preview : `params`, value: {data, language}})
    //yield call(api.setLanguage, language) 
    const response = yield call(api.signup2, data)
    yield call(api.clearLanguage) 

    if (response && response.ok) {
      console.tron.display({name: `authSagas`, preview : `api response`, value: {response: response}})
      const { data } = response
      const apiResponse = data
      const user = apiResponse.data[0]
      const userCurrency = typeof user.Currency == 'undefined' || user.Currency == null ? null : user.Currency
			const token = apiResponse.accessToken
      console.tron.display({name: `authSagas`, preview : `user & token`, value: {user: user, token: token}})
      yield call(api.setAuthorization, token)
      yield put(AuthActions.authSuccess(response))
      if (userCurrency == null)
        yield put(UserActions.setUserDefaultCurrency())
      yield put({ type : 'WEBSOCKET_INIT' })

			// if we have authBackup, then use that authorization to add the new user to old user/group
			const appState = yield select()
			const authState = appState.auth
			if (authState.authBackup && authState.authBackup.token) {
				// this was an addProfile call to signup
				const InvitingAccessToken = authState.authBackup.token
				console.log("signup calling addUserToGroup")
				const groupResponse = yield call(api.addUserToGroup, InvitingAccessToken)
				// if not groupResponse.ok then there is not much we can do about it
				if (groupResponse.ok) {
					console.log("signup calling addUserToGroup failed")
					const groupAPIResponse = groupResponse.data
					const groupData = groupAPIResponse.data
					console.log("signup data contents: " + JSON.stringify(groupData))
					const userUpdate = groupData.User
					const groupRecord = groupData.Group
					yield put(AuthActions.updateUserAndGroup(userUpdate, groupRecord)) // only currently using userUpdate
				}
				else
					console.log("signup calling addUserToGroup failed") // not much we can do...
			}
			yield call(getGroup)
		} else if (response && !response.ok) {
      if (response && 
          response.data && 
          response.data.errors && 
          response.data.errors.length > 0 && 
          response.data.errors[0])
      {
        const error = response.data.errors[0]
        const fieldErrors = error.fieldErrors ? error.fieldErrors : null
        console.tron.display({name: `authSagas`, preview : `failed`, value: {response, error, fieldErrors}})
        let errors = {}
        if (fieldErrors) {
          for (let i = 0; i < fieldErrors.length; i++) {
            const entry = fieldErrors[i]
            const { name, status } = entry
            errors[name != 'TermsOfUseAccepted' ? name.toLowerCase() : 'accept'] = status
          }
        }
        else {
          errors['username'] = "Error: " + error['detail']
        }
        console.tron.display({name: `authSagas`, preview : `failed2`, value: {errors: errors}})
        yield put(AuthActions.signupFailure(errors))
      }
      // this is handled by another popup in SignUpSaga.js, dont double-alert
      //else  alertView("Signup failed", "Please check your network connection and try again.")

    }
    else {
       
      alertView("DEBUG Signup failed", "final else in AuthSagas.js")
    }
  }
  catch (e) {
    // this pops but app is dead after (found it was due to nothing in one of the response fields above)
    alertView("Signup failed", "Please check your network connection and try again.  e.message = " + e.message)
    console.tron.display({name: `authSagas`, preview : `exception`, value: {message: e.message}})
    console.log("signup catch in auth sagas " + e.message)
    const errors = {message: e.message}
    // why are we doing facebook stuff here, get rid of it for now
    // DEBUG:  remove:  yield put(AuthActions.facebookSignupFailure(errors)) // should this be FB fail?  this seems like ordinary signup
  }
}

/*
// not necessary, as we are just updating the store, so just the initial redux call does the work...
const updateAuthUser = function* update(api, action) {
  try {
    const { user } = action
    console.tron.display({name: `authSagas`, preview : `updateAuthUser`, value: {user: user}})
    yield put(AuthActions.authUpdateSuccess(user))
  }
  catch (e) {
    console.tron.display({name: `authSagas`, preview : `updateAuthUser exception`, value: {message: e.message}})
  }
}
*/

export { getGroup, groupAddUser, groupRemoveUser, switchToGroupUser, addProfile, cancelAddProfile, loginUser, logoutUser, renewToken, updateKargoePassword, loginFacebook, signupFacebook, setMode, changePassword, nonSagaLogin, signup, /* updateAuthUser */  }
